var _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSingleEntityDistribution = function SvgSingleEntityDistribution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 195,
    height: 94,
    fill: "none",
    viewBox: "0 0 195 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M0 0h194.333v94H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M97 43h-1V27h1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 112.992,
    y: 66.941,
    fill: "#4B5563",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 65.342,
    y: 66.981,
    fill: "#4B5563",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 12,
    x: 80.667,
    y: 39,
    fill: "#4B5563",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M73.791 64.189a3.5 3.5 0 0 1 3.5-3.5h16a4.5 4.5 0 0 0 4.5-4.5v-5.17h-1v5.17a3.5 3.5 0 0 1-3.5 3.5h-16a4.5 4.5 0 0 0-4.5 4.5v2.83h1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M120.791 64.189a3.5 3.5 0 0 0-3.5-3.5h-16a4.5 4.5 0 0 1-4.5-4.5v-5.17h1v5.17a3.5 3.5 0 0 0 3.5 3.5h16a4.5 4.5 0 0 1 4.5 4.5v2.83h-1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.667,
    cy: 19,
    r: 8,
    fill: "#4B5563"
  })));
};
export default SvgSingleEntityDistribution;